import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// axios.defaults.baseURL = 'http://localhost:3030';
axios.defaults.baseURL =
  'https://phonebook-crud-deploy-b8f4ca01b4c0.herokuapp.com/';

const setToken = token => {
  return (axios.defaults.headers.common.Authorization = `Bearer ${token}`);
};

const unsetToken = () => {
  return (axios.defaults.headers.common.Authorization = '');
};

const register = createAsyncThunk('auth/register', async credentials => {
  try {
    const { data } = await axios.post('/api/users/auth/register', credentials);
    return data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

const logIn = createAsyncThunk('auth/login', async credentials => {
  try {
    const { data } = await axios.post('/api/users/auth/login', credentials);
    setToken(data.token);
    return data;
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

const logOut = createAsyncThunk('auth/logout', async () => {
  try {
    await axios.post('/api/users/auth/logout');
    unsetToken();
  } catch (error) {
    throw new Error(error.response.data.message);
  }
});

const fetchCurrentUser = createAsyncThunk(
  'auth/refresh',
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const savedToken = state.auth.token;

    if (savedToken === null) {
      return thunkAPI.rejectWithValue();
    }

    setToken(savedToken);
    try {
      const { data } = await axios.get('api/users/current');
      return data.user;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  },
);

const operations = {
  register,
  logIn,
  logOut,
  fetchCurrentUser,
};

export default operations;
